import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import InboundETransferInfo from './InboundETransferInfo';
import useFetchInboundETransferTransaction from '../../../../hooks/useApi/useFetchInboundETransferTransaction';

type FC = FunctionComponent<vp.TransactionId>;

const InboundETransferTransactionContainer: FC = (props: vp.TransactionId) => {
  const { TransactionID } = props;
  const [inboundETransferTransaction, getFetchInboundETransferTransaction] = useFetchInboundETransferTransaction({});
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InboundETransferList>();

  useEffect(() => {
    getFetchInboundETransferTransaction({
      TransactionID,
    });
  }, [TransactionID]);

  useEffect(() => {
    if (inboundETransferTransaction) {
      setTransaction(inboundETransferTransaction.Transactions);
    }
  }, [inboundETransferTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      <InboundETransferInfo transaction={transaction} />
    </div>
  );
};

export default InboundETransferTransactionContainer;
